/* i18n : PP_T(cle, repli FR, params) est defini et expose sur window.PP_T par permatan.js,
   charge AVANT ce fichier (defer, meme ordre que dans layout/theme.liquid). Ne jamais le
   redefinir ici : une declaration « function PP_T » ecraserait la version a trois parametres
   et les jetons {{ amount }} / {{ count }} ne seraient plus remplaces. Repli identique
   uniquement si l'ordre de chargement change un jour. */
if (typeof window.PP_T !== 'function') {
  window.PP_T = function (k, d, p) {
    var s = (window.PP_I18N && window.PP_I18N[k]) || d || '';
    if (p) {
      Object.keys(p).forEach(function (n) {
        s = s.replace(new RegExp('\\{\\{\\s*' + n + '\\s*\\}\\}', 'g'), function () { return String(p[n]); });
      });
    }
    return s;
  };
}
/* PERMATAN Parapharmacie — JS du thème.
   - Header : burger mobile ([data-pp-burger] / [data-pp-mnav], accordéons [data-pp-mnav-sub]),
     sous-menus bureau ([data-pp-sub-item]), panneau de recherche ([data-pp-search-toggle] /
     [data-pp-search]), suggestions ([data-pp-search-form][data-pp-suggest-url]) et repli
     automatique en burger quand la barre bureau déborde ([data-pp-header])
   - Section achat pp-formats ([data-ppf]) : sélection de pack, ajout panier
     via window.PMT (permatan.js), barre sticky (toutes largeurs : après le hero,
     hors section achat et footer, avec le nom du pack et son prix).
   - Recherche : joker de préfixe « * » ajouté au dernier terme à la soumission
     (Shopify ignore options[prefix]=last sur cette boutique, R1-3).
   - Fallback reveal pour les navigateurs sans animation-timeline: view(). */
(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */
  function initBurger() {
    var btn = document.querySelector('[data-pp-burger]');
    var nav = document.querySelector('[data-pp-mnav]');
    if (!btn || !nav) return;
    var labelOpen = btn.getAttribute('data-label-open') || btn.getAttribute('aria-label') || '';
    var labelClose = btn.getAttribute('data-label-close') || labelOpen;
    function setOpen(open) {
      if (open) nav.removeAttribute('hidden'); else nav.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (labelOpen) btn.setAttribute('aria-label', open ? labelClose : labelOpen);
    }
    btn.addEventListener('click', function () {
      setOpen(nav.hasAttribute('hidden'));
    });
    nav.querySelectorAll('[data-pp-mnav-link]').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    /* Sous-menus (niveau 2) en accordéon */
    nav.querySelectorAll('[data-pp-mnav-sub]').forEach(function (tg) {
      var panel = document.getElementById(tg.getAttribute('aria-controls') || '');
      if (!panel) return;
      tg.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    /* Échap : ferme le menu et rend le focus au burger */
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        setOpen(false);
        btn.focus();
      }
    });
  }

  /* ---------- Sous-menus bureau (menu déroulant accessible) ---------- */
  function initDesktopNav() {
    var items = document.querySelectorAll('[data-pp-sub-item]');
    if (!items.length) return;
    function setItem(item, open) {
      item.classList.toggle('is-open', open);
      var b = item.querySelector('[data-pp-sub-btn]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) setItem(it, false); });
    }
    items.forEach(function (item) {
      var b = item.querySelector('[data-pp-sub-btn]');
      if (!b) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !item.classList.contains('is-open');
        closeAll(item);
        setItem(item, open);
      });
      /* Survol souris : synchronise aria-expanded avec l'ouverture CSS (:hover) */
      item.addEventListener('mouseenter', function () { closeAll(item); setItem(item, true); });
      item.addEventListener('mouseleave', function () { setItem(item, false); });
      /* Clavier : le focus qui entre dans l'élément ouvre le sous-menu, celui qui en sort le ferme */
      item.addEventListener('focusin', function () { closeAll(item); setItem(item, true); });
      item.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !item.contains(e.relatedTarget)) setItem(item, false);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          setItem(item, false);
          b.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      var inside = false;
      items.forEach(function (it) { if (it.contains(e.target)) inside = true; });
      if (!inside) closeAll(null);
    });
  }

  /* ---------- Recherche : panneau bureau (loupe) ---------- */
  function initSearch() {
    var toggle = document.querySelector('[data-pp-search-toggle]');
    var panel = document.querySelector('[data-pp-search]');
    if (!toggle || !panel) return;
    var input = panel.querySelector('[data-pp-search-input]');
    var closeBtn = panel.querySelector('[data-pp-search-close]');
    function setOpen(open, refocus) {
      if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && input) { try { input.focus(); } catch (e) {} }
      if (!open && refocus) { try { toggle.focus(); } catch (e) {} }
    }
    toggle.addEventListener('click', function () { setOpen(panel.hasAttribute('hidden'), false); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false, true); });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); setOpen(false, true); }
    });
    document.addEventListener('click', function (e) {
      if (panel.hasAttribute('hidden')) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      setOpen(false, false);
    });
  }

  /* ---------- Recherche : suggestions (recherche prédictive Shopify, /search/suggest.json) ----------
     Uniquement des produits (titre + vignette), sans prix : les tarifs dépendent du contexte
     (B2B HT via catalogues, B2C TTC) et la page de résultats fait foi. Toute erreur est silencieuse :
     le formulaire reste un simple GET vers la page de recherche. */
  function initSuggest() {
    var forms = document.querySelectorAll('[data-pp-search-form][data-pp-suggest-url]');
    if (!forms.length || !window.fetch) return;
    forms.forEach(function (form) {
      var url = form.getAttribute('data-pp-suggest-url');
      var input = form.querySelector('[data-pp-search-input]');
      var box = form.querySelector('[data-pp-suggest]');
      if (!url || !input || !box) return;
      var allLabel = form.getAttribute('data-pp-suggest-all') || '';
      var noneLabel = form.getAttribute('data-pp-suggest-none') || '';
      var timer = null, ctrl = null, last = '';

      function clear() {
        box.textContent = '';
        box.setAttribute('hidden', '');
        last = '';
      }
      function thumb(p) {
        var src = (p.featured_image && p.featured_image.url) || p.image || '';
        if (!src) { var ph = document.createElement('span'); ph.className = 'pp-hd-suggest-ph'; ph.setAttribute('aria-hidden', 'true'); return ph; }
        var img = document.createElement('img');
        img.className = 'pp-hd-suggest-img';
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
        img.alt = '';
        img.width = 44; img.height = 44; img.loading = 'lazy';
        return img;
      }
      function render(products, q) {
        box.textContent = '';
        if (!products.length) {
          var none = document.createElement('p');
          none.className = 'pp-hd-suggest-none';
          none.textContent = noneLabel;
          box.appendChild(none);
          box.removeAttribute('hidden');
          return;
        }
        var ul = document.createElement('ul');
        ul.className = 'pp-hd-suggest-list';
        products.forEach(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'pp-hd-suggest-item';
          a.href = p.url;
          a.appendChild(thumb(p));
          var t = document.createElement('span');
          t.textContent = p.title || '';
          a.appendChild(t);
          li.appendChild(a);
          ul.appendChild(li);
        });
        box.appendChild(ul);
        var all = document.createElement('a');
        all.className = 'pp-hd-suggest-all';
        all.href = form.getAttribute('action') + '?q=' + encodeURIComponent(q);
        all.textContent = allLabel;
        box.appendChild(all);
        box.removeAttribute('hidden');
      }
      function run() {
        var q = (input.value || '').trim();
        if (q.length < 2) { clear(); return; }
        if (q === last) return;
        last = q;
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var u = url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(u, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || q !== (input.value || '').trim()) return;
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            render(prods, q);
          })
          .catch(function () { /* silencieux : le formulaire classique reste fonctionnel */ });
      }
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(run, 250);
      });
      /* Échap : efface les suggestions et laisse remonter l'événement (le panneau bureau ou le
         menu mobile se ferme dans la même frappe). */
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') clear();
      });
      form.addEventListener('submit', function () { clearTimeout(timer); });
    });
  }

  /* ---------- Repli automatique du header bureau ----------
     Si la barre (menu saisi par le client + téléphone + compte + CTA) déborde, on bascule
     sur la barre mobile + burger plutôt que de laisser les liens se chevaucher. */
  function initHeaderFit() {
    var hd = document.querySelector('[data-pp-header]');
    var wide = hd && hd.querySelector('.pp-hd-wide');
    var nav = hd && hd.querySelector('.pp-hd-nav');
    if (!hd || !wide || !nav) return;
    var raf = 0;
    /* Le menu (min-width:0) est le seul enfant qui se comprime : s'il a besoin de plus
       de place qu'il n'en a, ses liens chevauchent le bloc téléphone/compte/CTA. */
    function overflow() {
      return nav.scrollWidth > nav.clientWidth + 1 || wide.scrollWidth > wide.clientWidth + 1;
    }
    function fit() {
      hd.classList.remove('pp-hd--collapsed');
      hd.classList.remove('pp-hd--tighter');
      if (window.innerWidth < 1200) return; /* déjà en burger via CSS */
      /* 1. mise en page normale ; 2. mode serré ; 3. mode très serré ; 4. repli en burger */
      hd.classList.remove('pp-hd--tight');
      if (!overflow()) return;
      hd.classList.add('pp-hd--tight');
      if (!overflow()) return;
      hd.classList.add('pp-hd--tighter');
      if (overflow()) hd.classList.add('pp-hd--collapsed');
    }
    var settle = 0;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fit);
      /* seconde mesure une fois la mise en page stabilisée (resize par paliers, zoom, fonts) */
      clearTimeout(settle);
      settle = setTimeout(fit, 200);
    }
    fit();
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule).catch(function () {});
  }

  /* ---------- Section achat ---------- */
  function initFormats() {
    var root = document.querySelector('[data-ppf]');
    if (!root) return;
    var dataEl = root.querySelector('[data-ppf-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var stage = root.querySelector('[data-ppf-stage]');
    var mlEl = root.querySelector('[data-ppf-ml]');
    var descEl = root.querySelector('[data-ppf-desc]');
    var saveWrap = root.querySelector('[data-ppf-save]');
    var saveText = root.querySelector('[data-ppf-save-text]');
    var atcBtn = root.querySelector('[data-ppf-atc]');
    var atcPrice = root.querySelector('[data-ppf-atc-price]');
    var atcLabel = root.querySelector('[data-ppf-atc-label]');
    var opts = root.querySelectorAll('[data-ppf-opt]');
    var stickyName = document.querySelector('[data-ppf-sticky-name]');
    var stickyPrice = document.querySelector('[data-ppf-sticky-price]');

    var current = null;
    if (opts.length === 0) {
      /* Mode pro (aucun sélecteur B2C rendu) : afficher le flacon à l'unité, pas le Pack 4 */
      for (var i = 0; i < variants.length; i++) {
        if (!(variants[i].sku ? /PACK|KIT/i.test(variants[i].sku) : /Pack|Kit/i.test(variants[i].name))) { current = variants[i]; break; }
      }
    } else {
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].sku ? /PACK2/i.test(variants[i].sku) : /Pack ?(de |of )?2/i.test(variants[i].name)) && variants[i].available) current = variants[i];
      }
    }
    if (!current) current = variants[0];

    function apply(v) {
      current = v;
      if (stage && v.img) stage.src = v.img;
      if (mlEl) mlEl.textContent = v.ml || '';
      if (descEl) descEl.textContent = v.desc || '';
      if (saveWrap && saveText) {
        if (v.save_f) {
          saveText.textContent = PP_T('you_save', "Vous économisez") + ' ' + v.save_f + ' ' + PP_T('vs_unit', "par rapport au flacon à l’unité");
          saveWrap.style.display = 'flex';
        } else {
          saveWrap.style.display = 'none';
        }
      }
      /* [data-ppf-ship] : ligne de frais de port rendue par Liquid (snippet ship-line, D4-4), plus réécrite ici. */
      if (atcPrice) atcPrice.textContent = v.price_f || '';
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel && !v.available) atcLabel.textContent = PP_T('sold_out', 'Rupture de stock');
      }
      if (stickyName) stickyName.textContent = v.name || '';
      if (stickyPrice) stickyPrice.textContent = v.price_f || '';
      opts.forEach(function (opt) {
        var on = opt.getAttribute('data-vid') === String(v.id);
        opt.setAttribute('aria-checked', on ? 'true' : 'false');
        var dot = opt.querySelector('[data-ppf-dot]');
        var ring = opt.querySelector('[data-ppf-ring]');
        if (dot) dot.style.display = on ? '' : 'none';
        if (ring) ring.style.display = on ? '' : 'none';
      });
    }

    opts.forEach(function (opt) {
      function select() {
        var vid = opt.getAttribute('data-vid');
        var v = variants.filter(function (x) { return String(x.id) === vid; })[0];
        if (v) apply(v);
      }
      opt.addEventListener('click', select);
      opt.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(); }
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!current || !current.available) return;
        if (window.PMT && window.PMT.addToCart) {
          window.PMT.addToCart(current.id, current.name, atcBtn);
        } else {
          /* Repli sans permatan.js : URL prefixee par la racine de la locale (« /es », « /en »). */
          var root = (window.PP_RACINE && window.PP_RACINE !== '/') ? String(window.PP_RACINE).replace(/\/$/, '') : '';
          window.location.href = root + '/cart/add?id=' + current.id + '&quantity=1&return_to=' + root + '/cart';
        }
      });
    }

    /* Barre sticky : renvoie au sélecteur (ancre du markup). À TOUTES les largeurs (D1-6) :
       visible une fois le hero dépassé, masquée quand la section achat est à l'écran
       (doublon du bouton d'achat) ou près du footer. */
    var sticky = document.querySelector('[data-ppf-sticky]');
    var section = root.closest('section');
    if (sticky && section) {
      sticky.setAttribute('data-ppf-ready', '');
      var onScroll = function () {
        var hero = document.getElementById('hero2') || document.querySelector('.pp1');
        var heroPast = hero ? hero.getBoundingClientRect().bottom < 0 : (window.scrollY || 0) > 500;
        var rect = section.getBoundingClientRect();
        var formatsOnScreen = rect.top < window.innerHeight && rect.bottom > 0;
        var footer = document.getElementById('footer2') || document.querySelector('footer');
        var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        if (heroPast && !formatsOnScreen && !nearFooter) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    apply(current);
  }

  /* ---------- Recherche : joker de préfixe à la soumission (R1-3) ----------
     Shopify ignore options[prefix]=last sur cette boutique : « lot » ne trouve pas
     « lotion » alors que les suggestions le proposent (elles cherchent par préfixe).
     À la soumission d'un formulaire de recherche (en-tête, 404, page de résultats),
     le dernier terme reçoit « * », sauf s'il en a déjà un, s'il est entre guillemets
     ou s'il est trop court. Sans JavaScript, le formulaire part tel quel. */
  function initSearchWildcard() {
    document.querySelectorAll('form[role="search"]').forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      if (!input || form.dataset.ppWildcard) return;
      form.dataset.ppWildcard = '1';
      form.addEventListener('submit', function () {
        var q = (input.value || '').trim();
        if (q.length < 2 || /[*"]$/.test(q) || (q.split('"').length - 1) % 2 === 1) return;
        input.value = q + '*';
      });
    });
  }

  /* ---------- Fallback reveal (pas d'animation-timeline: view()) ---------- */
  function initReveals() {
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
    var els = document.querySelectorAll('[style*="view()"]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'none';
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var count = 0;
    els.forEach(function (el) {
      el.style.animation = 'none';
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px) scale(.985)';
      el.style.transition = 'opacity .65s cubic-bezier(.22,.61,.36,1) ' + ((count % 4) * 90) + 'ms, transform .65s cubic-bezier(.22,.61,.36,1) ' + ((count % 4) * 90) + 'ms';
      count++;
      io.observe(el);
    });
  }

  function init() {
    initBurger();
    initDesktopNav();
    initSearch();
    initSuggest();
    initHeaderFit();
    initSearchWildcard();
    initFormats();
    initReveals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();